import { createContext, useContext } from "react";
import { type ManagerArena } from "./AppContext";

export const PortalArenaContext = createContext<ManagerArena | undefined>(undefined);

export const usePortalArenaContext = () =>
  useContext<ManagerArena | undefined>(PortalArenaContext);
